<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { checkName, setupAccount, login } from "../services/auth-api";

const router = useRouter();
const loginName = ref("");
const loginPassword = ref("");
const errorMsg = ref("");
const loading = ref(false);
const showSetup = ref(false);
const setupName = ref("");
const setupStage = ref("");
const setupWechat = ref("");
const newPassword = ref("");
const setupError = ref("");
const showLoginPw = ref(false);
const showNewPw = ref(false);
const stages = ["准备", "初级", "二级", "已结业"];

async function doLogin() {
  errorMsg.value = "";
  const n = loginName.value.trim();
  const pw = loginPassword.value;
  if (!n) { errorMsg.value = "请输入姓名"; return; }
  if (!pw) { errorMsg.value = "请输入密码"; return; }
  loading.value = true;
  try {
    const result = await checkName(n);
    if (!result.success) {
	      errorMsg.value = result.error?.includes("空间已到期") ? result.error : "用户名不存在";
	      loading.value = false; return;
	    }
    if (result.isNewUser) {
      if (pw !== "111111") { errorMsg.value = "初始密码不正确。首次登录请输入初始密码：111111"; loading.value = false; return; }
      setupName.value = result.prefill?.name ?? n;
      setupStage.value = result.prefill?.stage ?? "";
      setupWechat.value = result.prefill?.wechat ?? "";
      showSetup.value = true;
      errorMsg.value = "";
    } else {
      const r = await login(n, pw);
      if (!r.success) { errorMsg.value = "密码不正确"; }
      else { localStorage.setItem("rc_token", r.token!); localStorage.setItem("rc_user", JSON.stringify(r.user!)); router.replace({ name: "home" }); }
    }
  } catch (e) { errorMsg.value = "系统繁忙，请稍后再试"; }
  loading.value = false;
}

async function completeSetup() {
  setupError.value = "";
  const pw = newPassword.value;
  const st = setupStage.value;
  const wx = setupWechat.value.trim();
  if (!pw || pw.length < 4) { setupError.value = "密码至少4位"; return; }
  if (!st) { setupError.value = "请选择学习阶段"; return; }
  if (!wx) { setupError.value = "请填写微信号，方便组队联系"; return; }
  loading.value = true;
  try {
    const r = await setupAccount(setupName.value, "111111", pw, st, wx);
    if (!r.success) { setupError.value = r.error ?? "设置失败"; loading.value = false; return; }
    localStorage.setItem("rc_token", r.token!);
    localStorage.setItem("rc_user", JSON.stringify(r.user!));
    router.replace({ name: "home" });
  } catch (e) { setupError.value = "系统繁忙，请稍后再试"; }
  loading.value = false;
}

const showForgot = ref(false);
const forgotName = ref("");
const forgotWechat = ref("");
const forgotPassword = ref("");
const forgotError = ref("");
const forgotSuccess = ref(false);

function openForgot() {
  forgotName.value = loginName.value;
  forgotWechat.value = "";
  forgotPassword.value = "";
  forgotError.value = "";
  forgotSuccess.value = false;
  errorMsg.value = "";
  showForgot.value = true;
}

async function doForgotPassword() {
  forgotError.value = "";
  const n = forgotName.value.trim();
  const wx = forgotWechat.value.trim();
  const pw = forgotPassword.value;
  if (!n) { forgotError.value = "请输入姓名"; return; }
  if (!wx) { forgotError.value = "请输入微信号"; return; }
  if (!pw || pw.length < 4) { forgotError.value = "新密码至少4位"; return; }
  loading.value = true;
  try {
    const res = await fetch("/api/auth/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: n, wechat: wx, newPassword: pw })
    });
    const data = await res.json();
    if (!data.success) { forgotError.value = data.error ?? "重置失败"; loading.value = false; return; }
    forgotSuccess.value = true;
  } catch (e) { forgotError.value = "系统繁忙，请稍后再试"; }
  loading.value = false;
}

function backToLogin() {
  showForgot.value = false;
  forgotSuccess.value = false;
}
</script>

<template>
  <div class="login-page">
    <div class="login-card">
      <h1 class="login-title">生命教练互助平台</h1>
      <p class="login-sub">空间有效期内生命教练专属</p>
      <div class="login-form" v-if="!showSetup">
        <label class="field-label">姓名</label>
        <input v-model="loginName" type="text" class="input" placeholder="请输入福多多幸福家用户名" @keyup.enter="doLogin" />
        <label class="field-label">密码</label>
        <div class="pw-wrap">
          <input v-model="loginPassword" :type="showLoginPw ? 'text' : 'password'" class="input pw-input" placeholder="请输入密码" @keyup.enter="doLogin" />
          <span class="pw-toggle" @click="showLoginPw = !showLoginPw">{{ showLoginPw ? '🙈' : '👁' }}</span>
        </div>
        <p class="init-hint">💡 首次登录？初始密码：111111 ｜ 老用户请输入自己设置的密码</p>
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
        <button class="btn-primary" :disabled="loading" @click="doLogin">{{ loading ? "验证中..." : "登录" }}</button>
        <p class="forgot-link" @click="openForgot">忘记密码？</p>
      </div>
      <div class="forgot-form" v-if="showForgot">
        <template v-if="!forgotSuccess">
          <div class="setup-banner">通过微信号验证重置密码</div>
          <label class="field-label">姓名</label>
          <input v-model="forgotName" type="text" class="input" placeholder="请输入福多多幸福家用户名" />
          <label class="field-label">微信号</label>
          <input v-model="forgotWechat" type="text" class="input" placeholder="请输入注册时的微信号" />
          <label class="field-label">设置新密码</label>
          <input v-model="forgotPassword" type="password" class="input" placeholder="至少4位" />
          <p v-if="forgotError" class="error-msg">{{ forgotError }}</p>
          <button class="btn-primary" :disabled="loading" @click="doForgotPassword">{{ loading ? "验证中..." : "重置密码" }}</button>
          <p class="forgot-link" @click="backToLogin">← 返回登录</p>
        </template>
        <template v-else>
          <div class="setup-banner" style="background:#edf6f1;color:#3d7a5a;">✅ 密码重置成功！请返回登录页面，用新密码登录</div>
          <button class="btn-primary" @click="backToLogin">← 返回登录</button>
        </template>
      </div>
      <div class="setup-form" v-if="showSetup">
        <div class="setup-banner">{{ setupName }}，欢迎！首次登录请完成以下设置</div>
        <label class="field-label">设置新密码</label>
        <div class="pw-wrap">
          <input v-model="newPassword" :type="showNewPw ? 'text' : 'password'" class="input pw-input" placeholder="至少4位" />
          <span class="pw-toggle" @click="showNewPw = !showNewPw">{{ showNewPw ? '🙈' : '👁' }}</span>
        </div>
        <label class="field-label">学习阶段</label>
        <div class="chip-row">
          <button v-for="s in stages" :key="s" :class="['chip', { active: setupStage === s }]" @click="setupStage = s">{{ s }}</button>
        </div>
        <label class="field-label">微信号</label>
        <input v-model="setupWechat" type="text" class="input" placeholder="方便组队联系（必填）" />
        <p class="field-hint">用于小组内成员互相联系，仅同组成员可见</p>
        <p v-if="setupError" class="error-msg">{{ setupError }}</p>
        <button class="btn-primary" :disabled="loading" @click="completeSetup">{{ loading ? "设置中..." : "完成设置，进入平台" }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f5f0e8; padding: 20px; }
.login-card { background: #fff; border-radius: 20px; padding: 36px 28px; max-width: 400px; width: 100%; box-shadow: 0 4px 16px rgba(61,53,41,0.10); }
.login-title { font-size: 22px; font-weight: 700; color: #3d3529; text-align: center; margin-bottom: 4px; }
.login-sub { text-align: center; color: #8b7e6a; font-size: 13px; margin-bottom: 28px; }
.field-label { display: block; font-size: 13px; font-weight: 600; color: #3d3529; margin-bottom: 6px; margin-top: 16px; }
.input { width: 100%; padding: 12px 14px; border: 1px solid #e8e4df; border-radius: 10px; font-size: 15px; color: #3d3529; background: #fafaf8; outline: none; transition: border-color 0.2s; }
.input:focus { border-color: #e8894f; }
.init-hint { font-size: 12px; color: #b8a99a; margin-top: 8px; }
.field-hint { font-size: 11px; color: #b8a99a; margin-top: 4px; }
.error-msg { color: #d4786e; font-size: 13px; margin-top: 12px; padding: 8px 12px; background: #fdf3f1; border-radius: 8px; }
.pw-wrap { position: relative; }
.pw-input { padding-right: 42px; }
.pw-toggle { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); cursor: pointer; font-size: 18px; user-select: none; }
.btn-primary { width: 100%; margin-top: 20px; padding: 13px; background: #e8894f; color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 600; cursor: pointer; transition: background 0.2s; }
.btn-primary:hover { background: #c96d35; }
.btn-primary:disabled { background: #d4a58a; cursor: not-allowed; }
.forgot-link { text-align: center; font-size: 12px; color: #b8a99a; margin-top: 14px; cursor: pointer; }
.setup-banner { background: #fef5ee; color: #c96d35; padding: 14px 16px; border-radius: 12px; font-size: 14px; font-weight: 600; margin-bottom: 8px; line-height: 1.6; }
.chip-row { display: flex; gap: 8px; flex-wrap: wrap; }
.chip { padding: 8px 16px; border: 1px solid #e8e4df; border-radius: 20px; background: #fafaf8; font-size: 13px; color: #4a4744; cursor: pointer; transition: all 0.2s; }
.chip.active { background: #e8894f; color: #fff; border-color: #e8894f; }
</style>